import React, { useCallback, useMemo } from 'react'
import { Card, Tabs } from '@design-systems/canvas-ui'
import { useData, TYPES as DT } from '../context/DataContext'
import { getUniqueKeyName } from '../../../../common/helper'
import { getTabIdByNameSafe } from '../utils/tabUtils'

export default function TabsNav({ statusContent }) {
  const { state: d, dispatch: dd } = useData()

  const isTabErrored = useCallback(
    (tabName) => {
      const tabUid = getTabIdByNameSafe(d.template, d.tabUidByName, tabName)
      return (d?.errorCache?.tab || []).includes(tabUid)
    },
    [d],
  )

  const tabs = useMemo(
    () => d?.template?.dynamic_sections?.tabs || [],
    [d?.template],
  )

  return (
    <Card
      id="tab-rfi-main"
      variant="border"
      className="rfi-tabs-card rfi-tabs-surface"
    >
      <div className="rfi-tabs-row">
        <Tabs
          className="rfi-tabs-control"
          activeTab={d.activeTab}
          disableAdaptive
          onTabSelect={(activeTab) =>
            dd({ type: DT.SET_ACTIVE_TAB, payload: activeTab })
          }
        >
          {tabs.map((t) => (
            <Tabs.Item
              name={t.tab_name}
              key={getUniqueKeyName(t.tab_name, 'tab')}
              data-testid={getUniqueKeyName(t.tab_name, 'tab')}
            >
              <label
                className={
                  'hc8-fs-150 font-weight-500' +
                  (isTabErrored(t.tab_name) ? ' hc8-clr-alert' : '')
                }
              >
                {t.tab_name}
              </label>
            </Tabs.Item>
          ))}
        </Tabs>
        {statusContent && (
          <div className="rfi-tabs-status">{statusContent}</div>
        )}
      </div>
    </Card>
  )
}
